import {useEffect, useRef, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";

import {
    hitGtmHomeMatchBasicFlowResignationModal,
    HOME_MATCH_BASIC_DISABLE_LABEL,
    HOME_MATCH_BASIC_KEEP_ENABLED_LABEL
} from "../../tracking/home_match_basic_flow_gtm_events";
import type {IHomeMatchBasicPreferencesFlowTrackingContext} from "../../types/HomeMatchBasicPreferencesFlowTypes";

type LoadingAction = "keepEnabled" | "disable" | null;

interface IProps {
    isOpen: boolean;
    isSaving: boolean;
    onDisable: () => void;
    onKeepEnabled: () => void;
    onClose: () => void;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
}

export const HomeMatchBasicPreferencesFlowResignationModal = (props: IProps) => {
    const {isOpen, isSaving, onDisable, onKeepEnabled, onClose, trackingContext} = props;
    const wasViewTracked = useRef(false);
    const wasSaving = useRef(false);
    const [loadingAction, setLoadingAction] = useState<LoadingAction>(null);

    useEffect(() => {
        if (!isOpen) {
            wasViewTracked.current = false;
            return;
        }

        if (trackingContext && !wasViewTracked.current) {
            wasViewTracked.current = true;
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "view",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory
            });
        }
    }, [isOpen, trackingContext]);

    useEffect(() => {
        if (!isOpen) {
            setLoadingAction(null);
            wasSaving.current = false;
            return;
        }

        if (wasSaving.current && !isSaving) {
            setLoadingAction(null);
        }

        wasSaving.current = isSaving;
    }, [isOpen, isSaving]);

    const handleClose = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "close",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory
            });
        }

        onClose();
    };

    const handleKeepEnabled = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "click",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory,
                eventLabel: HOME_MATCH_BASIC_KEEP_ENABLED_LABEL
            });
        }

        setLoadingAction("keepEnabled");
        onKeepEnabled();
    };

    const handleDisable = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "click",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory,
                eventLabel: HOME_MATCH_BASIC_DISABLE_LABEL
            });
        }

        setLoadingAction("disable");
        onDisable();
    };

    return (
        <Modal isOpen={isOpen} className={resignationModalStyle} onModalClose={handleClose}>
            <Modal.CloseButton placement="right" variant="rounded" className={closeButtonStyle} />
            <Modal.Content className={resignationContentStyle}>
                <Text variant="headline_3" as="h2" className={resignationHeaderStyle}>
                    Na pewno chcesz wyłączyć dopasowanie ofert?
                </Text>
                <Text variant="body_copy_2" color="var(--colors-gray-800)">
                    Bez tej opcji <span className={boldTextStyle}>przestaniemy automatycznie wysyłać zapytania w Twoim imieniu.</span> Oznacza to, że najlepsze
                    okazje mogą Cię ominąć, a Ty wrócisz do samodzielnego przeglądania setek ogłoszeń. Na pewno chcesz szukać mieszkań na własną rękę?
                </Text>
                <div className={resignationActionsStyle}>
                    <Button
                        variant="filled_primary"
                        size="medium"
                        className={buttonStyle}
                        onClick={handleKeepEnabled}
                        disabled={isSaving}
                        isLoading={isSaving && loadingAction === "keepEnabled"}
                    >
                        <span className={buttonTextStyle}>ZOSTAWIAM DOPASOWANIE OFERT</span>
                    </Button>
                    <Button
                        variant="outlined_secondary"
                        size="medium"
                        className={buttonStyle}
                        onClick={handleDisable}
                        disabled={isSaving}
                        isLoading={isSaving && loadingAction === "disable"}
                    >
                        <span className={buttonTextStyle}>WYŁĄCZAM I SZUKAM SAMODZIELNIE</span>
                    </Button>
                </div>
            </Modal.Content>
        </Modal>
    );
};

const resignationModalStyle = css({
    sm: {
        width: "544px",
        borderRadius: 2
    },
    md: {
        width: "544px"
    }
});

const closeButtonStyle = css({
    m: 2
});

const resignationContentStyle = css({
    display: "flex",
    flexDirection: "column",
    p: 1.5,
    pb: 20,

    sm: {
        p: 3
    }
});

const resignationHeaderStyle = css({
    mb: 1,
    pr: "4rem"
});

const resignationActionsStyle = css({
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 2,
    p: 3,
    backgroundColor: "var(--colors-white)",
    zIndex: 10,

    sm: {
        position: "static",
        gridTemplateColumns: "1fr",
        p: 0,
        mt: 3
    }
});

const buttonStyle = css({
    width: "100%"
});

const buttonTextStyle = css({
    "@media (max-width: 375px)": {
        fontSize: "1.4rem"
    }
});

const boldTextStyle = css({
    fontWeight: 700
});
import {useEffect, useRef, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";

import {
    hitGtmHomeMatchBasicFlowResignationModal,
    HOME_MATCH_BASIC_DISABLE_LABEL,
    HOME_MATCH_BASIC_KEEP_ENABLED_LABEL
} from "../../tracking/home_match_basic_flow_gtm_events";
import type {IHomeMatchBasicPreferencesFlowTrackingContext} from "../../types/HomeMatchBasicPreferencesFlowTypes";

type LoadingAction = "keepEnabled" | "disable" | null;

interface IProps {
    isOpen: boolean;
    isSaving: boolean;
    onDisable: () => void;
    onKeepEnabled: () => void;
    onClose: () => void;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
}

export const HomeMatchBasicPreferencesFlowResignationModal = (props: IProps) => {
    const {isOpen, isSaving, onDisable, onKeepEnabled, onClose, trackingContext} = props;
    const wasViewTracked = useRef(false);
    const wasSaving = useRef(false);
    const [loadingAction, setLoadingAction] = useState<LoadingAction>(null);

    useEffect(() => {
        if (!isOpen) {
            wasViewTracked.current = false;
            return;
        }

        if (trackingContext && !wasViewTracked.current) {
            wasViewTracked.current = true;
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "view",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory
            });
        }
    }, [isOpen, trackingContext]);

    useEffect(() => {
        if (!isOpen) {
            setLoadingAction(null);
            wasSaving.current = false;
            return;
        }

        if (wasSaving.current && !isSaving) {
            setLoadingAction(null);
        }

        wasSaving.current = isSaving;
    }, [isOpen, isSaving]);

    const handleClose = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "close",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory
            });
        }

        onClose();
    };

    const handleKeepEnabled = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "click",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory,
                eventLabel: HOME_MATCH_BASIC_KEEP_ENABLED_LABEL
            });
        }

        setLoadingAction("keepEnabled");
        onKeepEnabled();
    };

    const handleDisable = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowResignationModal({
                eventAction: "click",
                sourceModal: trackingContext.sourceModal ?? trackingContext.eventName,
                eventCategory: trackingContext.eventCategory,
                eventLabel: HOME_MATCH_BASIC_DISABLE_LABEL
            });
        }

        setLoadingAction("disable");
        onDisable();
    };

    return (
        <Modal isOpen={isOpen} className={resignationModalStyle} onModalClose={handleClose}>
            <Modal.CloseButton placement="right" variant="rounded" className={closeButtonStyle} />
            <Modal.Content className={resignationContentStyle}>
                <Text variant="headline_3" as="h2" className={resignationHeaderStyle}>
                    Na pewno chcesz wyłączyć dopasowanie ofert?
                </Text>
                <Text variant="body_copy_2" color="var(--colors-gray-800)">
                    Bez tej opcji <span className={boldTextStyle}>przestaniemy automatycznie wysyłać zapytania w Twoim imieniu.</span> Oznacza to, że najlepsze
                    okazje mogą Cię ominąć, a Ty wrócisz do samodzielnego przeglądania setek ogłoszeń. Na pewno chcesz szukać mieszkań na własną rękę?
                </Text>
                <div className={resignationActionsStyle}>
                    <Button
                        variant="filled_primary"
                        size="medium"
                        className={buttonStyle}
                        onClick={handleKeepEnabled}
                        disabled={isSaving}
                        isLoading={isSaving && loadingAction === "keepEnabled"}
                    >
                        <span className={buttonTextStyle}>ZOSTAWIAM DOPASOWANIE OFERT</span>
                    </Button>
                    <Button
                        variant="outlined_secondary"
                        size="medium"
                        className={buttonStyle}
                        onClick={handleDisable}
                        disabled={isSaving}
                        isLoading={isSaving && loadingAction === "disable"}
                    >
                        <span className={buttonTextStyle}>WYŁĄCZAM I SZUKAM SAMODZIELNIE</span>
                    </Button>
                </div>
            </Modal.Content>
        </Modal>
    );
};

const resignationModalStyle = css({
    sm: {
        width: "544px",
        borderRadius: 2
    },
    md: {
        width: "544px"
    }
});

const closeButtonStyle = css({
    m: 2
});

const resignationContentStyle = css({
    display: "flex",
    flexDirection: "column",
    p: 1.5,
    pb: 20,

    sm: {
        p: 3
    }
});

const resignationHeaderStyle = css({
    mb: 1,
    pr: "4rem"
});

const resignationActionsStyle = css({
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 2,
    p: 3,
    backgroundColor: "var(--colors-white)",
    zIndex: 10,

    sm: {
        position: "static",
        gridTemplateColumns: "1fr",
        p: 0,
        mt: 3
    }
});

const buttonStyle = css({
    width: "100%"
});

const buttonTextStyle = css({
    "@media (max-width: 375px)": {
        fontSize: "1.4rem"
    }
});

const boldTextStyle = css({
    fontWeight: 700
});
